import { render } from "./TheBasesYCondicionesJPEGMAFIA.vue?vue&type=template&id=4b53f208"
const script = {}

import exportComponent from "/builds/hubevt/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__